export const JUNI_EMAILS = {
  support: 'support@learnwithjuni.com',
};
export const JUNI_PHONES = {
  support: '(650) 263-4306',
};
